import React from 'react';
import { Icon, Table } from 'antd';
import TablePageSize from '../../../../../common/components/TablePageSize';

const placeholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const CustomersTable = props => {
  const {
    customers,
    pages,
    onChangeTable,
    renderColumns,
    tableColumnsLen,
    customersLoading,
    handleClickRow,
    changePaginationSize,
    rowKey
  } = props;

  return (
    <div className="orders__table">
      <Table
        locale={{
          emptyText: customersLoading ? placeholder : 'Нет заказчиков',
        }}
        columns={renderColumns()}
        dataSource={customers}
        rowKey={rowKey || 'id'}
        pagination={{ pageSize: pages }}
        onRow={handleClickRow}
        onChange={onChangeTable}
        scroll={tableColumnsLen > 8 ? { x: '140%' } : { x: false }}
      />
      {customers.length > 0 ? (
        <TablePageSize
          pages={pages}
          changePaginationSize={changePaginationSize}
        />
      ) : null}
    </div>
  );
};

export default CustomersTable;
